import { render, staticRenderFns } from "./User_analysis.vue?vue&type=template&id=65ba1584&style=height%3A%20100%25%3B"
import script from "./User_analysis.vue?vue&type=script&lang=js"
export * from "./User_analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports